export default "__VITE_ASSET__CzNYSlCj__"